import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const NumberFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('NumberField'),
});

export type NumberField = z.infer<typeof NumberFieldSchema>;